module.exports = __webpack_public_path__ + "static/img/icon-linkend.29c9b7d2.svg";